import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../../components/Home/footer/Footer";
import { Link } from "react-router-dom";
import CarrerNav from "../../components/Navbar/CarrerNav";
import { Helmet } from "react-helmet";
import { header1, jobs, locationImg, teams, think } from "../../Assets";
function Carrers() {
  return (
    <>
      <Helmet>
        <title>Careers at Avijobs: Join Us for Transformation</title>
        <meta
          name="description"
          content="Explore exciting career opportunities at Avijobs. Be part of a team revolutionizing through technology, innovation, and operational excellence."
        />
      </Helmet>

      <div className="App">
        <CarrerNav />
        <Header />
        <ExploreOpportunities />
        <TeamMember />
        <Footer />
      </div>
    </>
  );
}

const Header = () => (
  <header className="hero bg-white p-8" style={{ fontFamily: "Gilroy-SemiBold" }}>
    <div className="flex justify-between p-4 md:flex-row">
      <div className="w-50 flex h-full flex-col p-12">
        <div className="w-100 flex-grow">
          <h2 className="text-4xl text-gray-700">
            Get Instant placement with KYC (Know Your Colleague)
          </h2>
          <span className="font-sans text-lg text-gray-600">
            We prioritize not just finding the right talent but also ensuring
            that our colleagues are well-connected and familiar with their
            workplace environment and colleagues from day one. Our unique KYC
            (Know Your Colleague) feature is designed to foster a sense of
            community and trust within our organization, providing an instant
            placement experience that seamlessly integrates new hires into our
            team.
          </span>
        </div>
        <Link to="/culture">
          <button className="mt-2 h-10 w-40 rounded-lg bg-[#0095D9]">
            <span className="text-sm text-white">Learn more</span>
          </button>
        </Link>
      </div>
      <div className="w-50 ml-40 mt-10 p-4">
        <img src={header1} alt="banner" className="w-90 h-60" />
      </div>
    </div>
  </header>
);

const ExploreOpportunities = () => (
  <section className="bg-white py-5">
    <h1
      className="m-10 text-center text-4xl font-semibold text-gray-500"
      style={{ fontFamily: "Gilroy-SemiBold" }}
    >
      Explore Opportunities
    </h1>

    <div className="explore container">
      <div className="row">
        <div className="col-md-4 text-center">
          <img src={teams} alt="Teams" className="img-fluid mb-3" />
          <h5 className="text-gray-500">Teams</h5>
          <p className="text-gray-500">
            Get to know Avijo's teams, from Avijo Web Services to subsidiaries.
          </p>
          <Link
            to="/joblistings"
            className="text-decoration-none"
            style={{ color: "#0095D9" }}
          >
            See All Teams
          </Link>
        </div>

        <div className="col-md-4 text-center">
          <img src={jobs} alt="Job Categories" className="img-fluid mb-3" />
          <h5 className="text-gray-500">Job Categories</h5>
          <p className="text-gray-500">
            Want to be an Avijo? Find the right job for you.
          </p>
          <Link
            to="/joblistings"
            className="text-decoration-none"
            style={{ color: "#0095D9" }}
          >
            See All Job Categories
          </Link>
        </div>

        <div className="col-md-4 text-center">
          <img src={locationImg} alt="Locations" className="img-fluid mb-3" />
          <h5 className="text-gray-500">Locations</h5>
          <p className="">View Avijo's office locations across the globe.</p>
          <Link
            to="/joblistings"
            className="text-decoration-none"
            style={{ color: "#0095D9" }}
          >
            See All Locations
          </Link>
        </div>
      </div>
    </div>
  </section>
);

const TeamMember = () => (
  <section className="mb-5 border-b-[40px] border-t-[40px] border-gray-50 py-5">
    <div className="team container">
      <div className="row justify-center">
        <div className="col-md-4 d-flex justify-center">
          <img
            src={think}
            alt="think"
            className="img-fluid w-50 mb-3 h-auto rounded-lg"
          />
        </div>
        <div className="col-md-8">
          <h5 className="text-gray-700">We Think & Learn more than Work</h5>
          <p className="text-gray-500">
            We believe in thinking and learning more than just working. Our
            culture encourages innovation, continuous learning, and
            collaboration, creating an environment where every team member can
            thrive and grow.
          </p>
          <Link to="/culture" className="btn btn-primary">
            Read More
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default Carrers;
